import { Navigate, Route, Routes } from 'react-router-dom';
import ModuleLayout from '@/components/module/ModuleLayout';
import { Layers } from 'lucide-react';
import ScmDashboard from '@/pages/scm/ScmDashboard';
import ScmSalesOrdersPage from '@/pages/scm/ScmSalesOrdersPage';
import ScmPurchaseOrdersPage from '@/pages/scm/ScmPurchaseOrdersPage';
import ScmProductsPage from '@/pages/scm/ScmProductsPage';
import ScmInventoryPage from '@/pages/scm/ScmInventoryPage';
import ScmQuotationsPage from '@/pages/scm/ScmQuotationsPage';
import ScmSuppliersPage from '@/pages/scm/ScmSuppliersPage';
import ScmRfqPage from '@/pages/scm/ScmRfqPage';
import ScmSalespersonsPage from '@/pages/scm/ScmSalespersonsPage';
import ScmStockMovementsPage from '@/pages/scm/ScmStockMovementsPage';
import ScmFulfillmentPage from '@/pages/scm/ScmFulfillmentPage';
import ScmShipmentTrackingPage from '@/pages/scm/ScmShipmentTrackingPage';
import ScmCostingPage from '@/pages/scm/ScmCostingPage';
import ScmReportsPage from '@/pages/scm/ScmReportsPage';

function ScmLayout() {
  return (
    <ModuleLayout
      title="SCM"
      subtitle="Supply Chain Management"
      icon={Layers}
      accentColor="text-cyan-600"
      moduleId="supply-chain"
    />
  );
}

export default function ScmRoutes() {
  return (
    <Routes>
      <Route element={<ScmLayout />}>
        <Route index element={<ScmDashboard />} />
        <Route path="sales-orders" element={<ScmSalesOrdersPage />} />
        <Route path="quotations" element={<ScmQuotationsPage />} />
        <Route path="customers" element={<Navigate to="/e/customers" replace />} />
        <Route path="purchase-orders" element={<ScmPurchaseOrdersPage />} />
        <Route path="suppliers" element={<ScmSuppliersPage />} />
        <Route path="rfq" element={<ScmRfqPage />} />
        <Route path="salespersons" element={<ScmSalespersonsPage />} />
        <Route path="products" element={<ScmProductsPage />} />
        <Route path="inventory" element={<ScmInventoryPage />} />
        <Route path="stock-movements" element={<ScmStockMovementsPage />} />
        <Route path="fulfillment" element={<ScmFulfillmentPage />} />
        <Route path="shipment-tracking" element={<ScmShipmentTrackingPage />} />
        <Route path="costing" element={<ScmCostingPage />} />
        <Route path="reports" element={<ScmReportsPage />} />
        <Route path="*" element={<Navigate to="/scm" replace />} />
      </Route>
    </Routes>
  );
}
